import React, { useEffect, useState } from "react";
import { ScreenContainerControl, LabelControl } from "doshx_controls_web";
import { useDispatch } from "react-redux";
import { cn, Tab, Tabs } from "@heroui/react";
import { getCustomContents } from "../../api/calls/client/custom_content";
import { setMainModal } from "../../reducers/slices/main";
import { Breadcrumb } from "../../components/breadcrumb";
import { ParagraphShimmer } from "../../components/shimmer/shimmer_types";
import { Shimmer } from "../../components/shimmer/shimmer";
import { NoContentMessage } from "../../components/no_content_message";
import { ConvertToHtmlComponent } from "../../components/convertToHtml";
export const AboutUsPage = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [aboutUs, setAboutUs] = useState([]);
    const [hero, setHero] = useState("");
    useEffect(() => {
        getCustomContents({ status: "published", placement: "about" }).then((response) => {
            setIsLoading(false);
            if (response.success) {
                const items = response.content?.contents ?? [];
                setAboutUs(items);
                const heroItem = items.find((item) => item.media?.url);
                if (heroItem) {
                    setHero(heroItem.media.url);
                }
            }
            else {
                setAboutUs([]);
                dispatch(setMainModal({ title: "Something went wrong!", messages: [response.message] }));
            }
        });
    }, []);
    return (React.createElement("div", null,
        React.createElement(Breadcrumb, { items: [{ label: "Home" }, { label: "About Us", active: true }], title: "About Us" }),
        hero && (React.createElement("div", { className: "w-full h-[700px] overflow-hidden md:mt-[-0.6rem] md:z-[-1] relative" },
            React.createElement("img", { src: hero, alt: "About Us", className: "w-full h-full object-cover" }))),
        React.createElement("div", { className: "w-full" }, isLoading ? (React.createElement(ScreenContainerControl, { className: "flex flex-col py-8 gap-6" },
            React.createElement(Shimmer, { width: "60%" }),
            React.createElement(ParagraphShimmer, null),
            React.createElement(ParagraphShimmer, null),
            React.createElement(ParagraphShimmer, null))) : aboutUs && aboutUs.length > 0 ? (React.createElement("div", { className: "bg-light-blue py-8" },
            React.createElement(ScreenContainerControl, null,
                React.createElement(Tabs, { variant: "solid", color: "primary", classNames: {
                        base: cn("pb-4"),
                        tabContent: cn("group-data-[selected=true]:border-b-2 group-data-[selected=true]:border-primary"),
                        cursor: cn("bg-transparent"),
                        tabList: cn("bg-transparent rounded-none gap-6 p-0"),
                        tab: cn("font-semibold p-0"),
                    } }, aboutUs.map((item) => (React.createElement(Tab, { key: item._id, title: React.createElement(LabelControl, { label: item.title, textColor: "text-primary", size: "large" }) },
                    React.createElement(ConvertToHtmlComponent, { htmlString: item.rich_text }),
                    " "))))))) : (React.createElement(ScreenContainerControl, { className: "py-8" },
            React.createElement(NoContentMessage, { messages: ["No content available for About Us"] }))))));
};
